
    if($('.type-detail').length){
        if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
            $('.p-thumbnail+a').remove();
            $('.p-image-wrapper').addClass('haveThumbnails');
            $('.p-image-wrapper .p-thumbnails').append('<button class="slider-arrow prev disabled">‹</button><button class="slider-arrow next">›</button>')
            $('.p-image-wrapper').append('<div class="dots"></div>')
        }
        else{
           $('.p-image-wrapper').append('<div class="p-thumbnails-wrapper oneImage"><div class="p-thumbnails"><div class="p-thumbnails-inner"><div><a href="'+$('.p-image a').attr('href')+'" class="p-thumbnail"><img src="'+$('.p-image img').attr('src')+'" data-src="'+$('.p-image img').attr('src')+'"></a></div></div></div></div>') 
        }
        function updateMainImage(highlightedThumbnail) {
            var findHighlighted = highlightedThumbnail.attr('href');
            var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
            $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
        }
        if ($('.p-thumbnail').length) {
            $.ajax({
                url: "https://videa.lasilueta.cz/api.php?v="+new Date().getMinutes(),
                type: "GET",
                data: { codes: getShoptetDataLayer('product').codes[0].code },
                dataType: "json",
               // xhrFields: { withCredentials: true }, 
                success: function (response) {
                    console.log(response)
                    let sku = getShoptetDataLayer('product').codes[0].code;
                        if (response.hasOwnProperty(sku)) {
                            let productData = response[sku];
                            var autoplayAttr = (productData.autostart == 1) ? " autoplay" : "controls";
                            if (productData.video !== null && productData.video !== undefined && productData.video !== "") {
                                $('.p-thumbnails-wrapper').addClass('haveVideo')
                                $('.p-thumbnails-wrapper').removeClass('oneImage')
                                $('.p-thumbnails-wrapper .p-thumbnail').first().after('<a href="/user/documents/'+productData.video+'" class="p-thumbnail"><video autoplay muted loop playsinline style="max-width: 100%;display: block;" poster="/user/documents/'+productData.video_thumb+'"><source src="/user/documents/'+productData.video+'" type="video/mp4"></video></a>')
                            }
                            
                        } else {
                            
                        }
                },
                error: function (xhr) {
                    console.error("Chyba při načítání API:", xhr.responseText);
                }
            }).done(function(){
                let totalThumbnails = $('.p-thumbnail').length;
                if (totalThumbnails > 6) {
                    let remaining = totalThumbnails - 6;
                    function correctForm(number) {
                        if (number === 1) {
                            return 'fotografie';
                        } else if (number >= 2 && number <= 6) {
                            return 'fotografie';
                        } else {
                            return 'fotografií';
                        }
                    }
            
                    let correctText = '+ ' + remaining + ' ' + correctForm(remaining);
                    $('.p-thumbnail').eq(5).addClass('haveThumb').append('<span class="thumbnailText">+ '+remaining+'</span>');
                }
                $(document).ready(function(){
                    let thumbnails = $(".p-thumbnails-inner"); // Kontejner pro miniatury
                    let prevButton = $(".prev"); // Levá šipka
                    let nextButton = $(".next"); // Pravá šipka
                    let dotsContainer = $(".dots"); // Puntíky pro přímý výběr
                
                    let items = $(".p-thumbnail"); // Všechny miniatury
                    let itemWidth = items.outerWidth(true); // Šířka jednoho prvku včetně marginu
                    let currentIndex = 0;
                    let totalItems = items.length;
                
                    function updateSlider() {
                        let targetElement = items.eq(currentIndex).get(0); // Získání konkrétní miniatury
                        let scrollPosition = targetElement.getBoundingClientRect().left - thumbnails.get(0).getBoundingClientRect().left + thumbnails.scrollLeft();
                        console.log(itemWidth)
                       
                        
                        thumbnails.animate({ scrollLeft: scrollPosition }, 300);
                
                        updateArrows();
                        updateDots();
                    }
                
                    function updateArrows() {
                        prevButton.toggleClass("disabled", currentIndex === 0);
                        nextButton.toggleClass("disabled", currentIndex === totalItems - 1);
                    }
                
                    function updateDots() {
                        $(".dot").removeClass("active");
                        $(".dot").eq(currentIndex).addClass("active");
                    }
                
                    function goToSlide(index) {
                        currentIndex = index;
                        updateSlider();
                    }
                
                    $('html').on('click', '.slider-arrow.prev', function () {
                        if (currentIndex > 0) {
                            currentIndex--;
                            updateSlider();
                        }
                    });
                
                    $('html').on('click', '.slider-arrow.next', function () {
                        if (currentIndex < totalItems - 1) {
                            currentIndex++;
                            updateSlider();
                        }
                    });
                
                    
                    // Vytvoření puntíků
                    for (let i = 0; i < totalItems; i++) {
                        dotsContainer.append(`<div class="dot ${i === 0 ? "active" : ""}" data-index="${i}"></div>`);
                    }
                
                    $("html").on('click', '.dot', function () {
                        let index = $(this).data("index");
                        goToSlide(index);
                    });
                
                    updateArrows();
                    updateDots();
                })
            });

            $('.p-thumbnail img').each(function(){
                $(this).attr('data-src', $(this).attr('data-src').replace('/related/', '/big/'))
            })
            
        }
    
        $('html').on('click', '.p-thumbnail', (function(){
            $('.cbox-gal[href="'+$(this).attr("href")+'"]').attr('href', $(this).attr("href")).trigger('click')
        }));
    }   


if ($('.p-thumbnails-inner a.p-thumbnail').length > 0) {
    if ($('.p-thumbnails-inner a.p-thumbnail').length > 1) {
        $('html').on('click', '.p-thumbnails-inner a.p-thumbnail', function (e) {
            e.preventDefault();
            var $link = $(this);
            var src = $link.attr('href');
            var isVideo = (src && src.match(/\.mp4(\?.*)?$/i)) ? true : false;
            var galleryItems = $('.p-thumbnails-inner a.p-thumbnail').map(function () {
                return {
                    href: $(this).attr('href'),
                    isVideo: $(this).attr('href').match(/\.(mp4|mov|m4v|avi|mkv|webm|ogg|ogv|wmv|flv|mpg|mpeg)(\?.*)?$/i) ? true : false
                };
            }).get();
            var currentIndex = galleryItems.findIndex(item => item.href === src);
            function showItem(index) {
                var item = galleryItems[index];
                var isVideo = item.isVideo;
                var htmlContent = isVideo
                    ? `<video autoplay muted loop playsinline style="width:100%;height:100%;">
                        <source src="${item.href}" type="video/mp4">
                        Váš prohlížeč nepodporuje video tag.
                    </video>`
                    : `<img src="${item.href}" class="cboxPhoto">`;

                $.colorbox({
                    rel: 'gallery',
                    html: htmlContent,
                    maxWidth: shoptet.modal.config.maxWidth,
                    maxHeight: shoptet.modal.config.maxHeight,
                    width: shoptet.modal.config.widthLg,
                    className: shoptet.modal.config.classLg + ' productDetailNew',
                    photo: !isVideo,
                    current: "{current} z {total}",
                    onComplete: function () {
                        $('#cboxPrevious, #cboxNext').show();
                        setTimeout(() => {
                            $('#cboxPrevious, #cboxNext').css('display', 'block');
                        }, 100);

                        if (isVideo) {
                            $('video').get(0).play();
                        }
                    },
                    onClosed: function () {
                        $('video').each(function () {
                           // this.pause();
                        });
                    }
                });
                currentIndex = index;
            }
            showItem(currentIndex);
            $(document).on('click', '#cboxPrevious', function () {
                var prevIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
                showItem(prevIndex);
            });
            $(document).on('click', '#cboxNext', function () {
                var nextIndex = (currentIndex + 1) % galleryItems.length;
                showItem(nextIndex);
            });
        });
    }
    else{
        $('html').on('click', '.p-thumbnails-inner a.p-thumbnail', function (e) {
            e.preventDefault();
            var $link = $(this);
            var src = $link.attr('href');
            $.colorbox({
                rel: 'gallery',
                html: '<img src="'+src+'" class="cboxPhoto">',
                maxWidth: shoptet.modal.config.maxWidth,
                maxHeight: shoptet.modal.config.maxHeight,
                width: shoptet.modal.config.widthLg,
                className: shoptet.modal.config.classLg + ' productDetailNew',
                current: "{current} z {total}",
                onComplete: function () {
                    
                },
                onClosed: function () {
                   
                }
            });
        });
    }
}